import React from "react";
import Link from "next/link";
import Background from "@/components/background";
import { BsLinkedin, BsGithub, BsFolder } from "react-icons/bs";

export default function LinkTree() {
  const links = [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/jockan/",
      description: "Connect with me professionally",
      icon: BsLinkedin,
    },
    {
      name: "GitHub",
      url: "https://github.com/joakim-lignerkrona",
      description: "Check out my code and projects",
      icon: BsGithub,
    },
    {
      name: "Projects",
      url: "/projects",
      description: "View some of my work",
      icon: BsFolder,
    },
  ];

  return (
    <>
      <Background>
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <h1
            className="display-4 fw-bold mb-3 text-gradient"
            style={{ outline: "0 2px 12px rgba(155, 155, 155, 1)" }}
          >
            Joakim Lignerkrona
          </h1>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card bg-glassy rounded-3">
                  <div className="card-body text-center">
                    <p className="mb-4 text-white">
                      Find me on these platforms
                    </p>

                    <div className="d-grid gap-3">
                      {links.map((link, index) => {
                        const IconComponent = link.icon;
                        return (
                          <Link
                            key={index}
                            href={link.url}
                            {...(link.url.startsWith("http")
                              ? { target: "_blank", rel: "noopener noreferrer" }
                              : {})}
                            className="btn btn-primary btn-lg w-100 d-flex align-items-center gap-3"
                            style={{
                              border: "none",
                              borderRadius: "12px",
                              padding: "1rem",
                              transition: "all 0.3s ease",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: "40px",
                                height: "40px",
                                flexShrink: 0,
                              }}
                            >
                              <IconComponent size={24} />
                            </div>
                            <div className="text-start flex-grow-1">
                              <div className="fw-semibold">{link.name}</div>
                              <div className="divider-gradient mt-1" />
                              <small className="text-white-50">
                                {link.description}
                              </small>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Background>
    </>
  );
}
